import React from 'react';

import {pure} from 'recompose';

import './TextInput.css';

const TextInput = (props) => (
  <textarea
    className="text-input"
    placeholder={"Ask Away Here"}
    value={props.text}
    onChange={props.onChange}
    onKeyDown={onEnter(props.onEnter)}
  />
)

function onEnter(cb) {
  return (e) => {
    if (e.keyCode === 13 && !e.shiftKey){
      e.preventDefault();
      cb();
    }
  }
}

export default pure(TextInput);



// WEBPACK FOOTER //
// ./src/components/TextInput.js